
const BASE_TIME = "2021-01-01";
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";
import * as echarts from "echarts";
import {
  dispatchPerforMance,
  dispatchDataValid,
  dispatchGetPerformanceDashboard,
  dispatchGetPerformancePageList,
  dispatchGetPerformanceSelectOptions,
  dispatchUploadPerformance,
  dispatchUploadPerformanceAll,
  dispatchGetPerformanceCustomVersionList,
} from "@/store/performance/actions";
import {
  dispatchGetMyProjects,
  dispatchGetProjectDetail,
  dispatchGetProjects,
  dispatchUpdateProject,
} from "@/store/project/actions";

import { store } from "@/store";
import {
  readPerfDashboard,
  readPerformancePageList,
  readPerformanceSelectOptions,
  readPerformanceCustomVersion,
} from "@/store/performance/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import {
  readMyProjects,
  readProjectScenes,
  readProjectDetail,
} from "@/store/project/getters";
import { dispatchGetProjectScenes } from "@/store/project/actions";
import { ElMessage } from "element-plus";
import { watchEffect } from "vue";
import { dispatchGetSimpleScripts } from "@/store/task/actions";
import { readSimpleScriptList } from "@/store/task/getters";
@Options({
  props: {
    searchVal: {},
  },
})
export default class SideMenu extends Vue {
  public localProject = Number(getLocalProject());
  public b = {
    rule_settings: {},
  };
  public c(searchVal) {
    this.b = searchVal;
    return searchVal;
  }
  public get customVersion_options() {
    return readPerformanceCustomVersion(store).version_list;
  }
  public loading = false;
  public basic_loading = false;
  public activeName = "first";
  public line_loading = false;
  // 场景、机型、版本选择
  public choice:any = {
    scene: "", //场景
  };
  public m = {};

  public typeForm = {
    faType: 0,
    sonType: "",
  };

  public valueTime = ref("");
  public timeDefaultShow: any = [];

  public PerfFields = [
    // { label: "序号", prop: "index", width: 60 },
    { label: "测试时间", prop: "timestamp", width: 180 },
    { label: "测试人员", prop: "tester", width: 100 },
    { label: "设备信息", prop: "model", width: 100 },
    { label: "游戏包名", prop: "project.pkg_name", width: 100 },
    { label: "地图名", prop: "scene_id.chinese", width: 100 },
    { label: "游戏版本", prop: "game_version", width: 100 },
    { label: "发布版本", prop: "custom_version", width: 100 },
    { label: "record_id", prop: "RecordID", width: 100 }, //在空数据加-- 里面处理过的
    { label: "测试类型", prop: "type_str", width: 100 }, //在空数据加-- 里面处理过的
    { label: "avgFPS", prop: "avg_fps", width: 100 },
    { label: "MinFPS", prop: "min_fps", width: 100 },
    { label: "FPS>18占有率(%)", prop: "fps_lt_18_pcnt", width: 100 },
    { label: "FPS>25占有率(%)", prop: "fps_lt_25_pcnt", width: 100 },
    { label: "avgCPU(%)", prop: "avg_cpu", width: 100 },
    { label: "CPU>60%占比", prop: "cpu_lt_60_pcnt", width: 100 },
    { label: "dps", prop: "dps", width: 100 },
    { label: "流量(KB/S)", prop: "avg_flow", width: 100 },
    { label: "maxVSS(MB)", prop: "max_vss", width: 100 },
    { label: "卡顿率(%)", prop: "lag_pcnt", width: 100 },
    { label: "maxMonoTotal(M)", prop: "max_mono_total", width: 100 },
    { label: "maxTriangle(万个)", prop: "max_triangle", width: 100 },
    { label: "maxDrawCall(次)", prop: "max_dc", width: 100 },
    { label: "GC(次)", prop: "gc_cnt", width: 100 },
    { label: "平均PSS", prop: "avg_pss", width: 100 },
    { label: "峰值PSS", prop: "max_pss", width: 100 },
  ];

  // 场景
  public selected_table_scene = [];
  // 设备
  public selected_table_device = [];
  // 版本
  public selected_table_version = [];
  // 是否有效
  public selected_table_judge = "";
  // record_id
  public indexValue = "";
  // 当前页
  public current_page = 1;
  public record = 16; //记录条数

  public dialogVisible = false; //上传性能数据弹窗
  public dialogVisibleRunmax = false; //上传runmax性能数据弹窗
  public dialogForm = {
    scene_id: "",
    script_id: "",
    is_valid: true,
    b_auto_collect: false,
    remark: "",
    UUID: "",
    task_record_id: "",
    task_group_index: "",
  };
  public dialogRunmaxForm = {
    task_record_id: "",
    task_group_index: "",
    UUID: "",
    script_id: "",
    scene_id: "",
  };
  public secondShow = true;
  // 页面初始化
  public async tabsChange() {
    if (this.activeName == "second" && this.secondShow == true) {
      dispatchGetSimpleScripts(store, { project: this.localProject });
      await dispatchGetPerformancePageList(store, {
        project: this.localProject,
        task_record_id: "",
        scene_id_list: [],
        device_id_list: [],
        game_versions: [],
        page: 1,
        size: this.record,
        is_valid: "",
        custom_versions: "",
      });
      await this.dataProcessing;
      this.secondShow = false;
    }
  }
  public mm = {};

  setDefaultVal() {
    if ([18, 14].includes(this.localProject)) {
      this.choice.scene = 83337
    } else {
      this.choice.scene = this.performace_select_options.scene_list[0]?.scene_id || "";
    }
    
    this.typeForm.faType = [18, 14].includes(this.localProject) ? 9 : 0
  }

  public async mounted() {
    this.timeDefaultShow = new Date();
    this.timeDefaultShow.setMonth(new Date().getMonth() - 1);
    this.loading = true;
    this.basic_loading = true;
    this.line_loading = true;

    
    this.typeForm.sonType = "0";
    // await  dispatchGetProjectDetail(store, {
    //   id: this.localProject,
    //   project: this.localProject,
    // });
    // console.log(readProjectDetail(store))
    dispatchGetDeviceSpecs(store, { project: this.localProject });

    //获取分页
    await dispatchGetProjectScenes(store, { project: this.localProject });
    // 下拉框
    await dispatchGetPerformanceSelectOptions(store, {
      project: this.localProject,
    });
    this.setDefaultVal()

    await dispatchGetPerformanceCustomVersionList(store, {
      project: this.localProject,
    });
    
    if (this.localProject === 34) {
      await this.$nextTick(() => {
        let time = setInterval(() => {
          if (JSON.stringify(this.b) !== "{}") {
            clearInterval(time);
            let setting = JSON.parse(this.b.rule_settings as any);

            if (setting.project_overview) {
              this.target_all = setting.project_overview;
            } else {
              setting.project_overview = {};
              this.platformArr.forEach((v) => {
                setting.project_overview[v.value] = {};

                this.performace_select_options.scene_list.forEach((i) => {
                  setting.project_overview[v.value][i.scene_id] = {};
                  this.typefaList.forEach((item) => {
                    setting.project_overview[v.value][i.scene_id][
                      item.value
                    ] = {};
                    this.sonList.forEach((k) => {
                      setting.project_overview[v.value][i.scene_id][item.value][
                        k.value
                      ] = {};
                      this.target_types.forEach((x) => {
                        setting.project_overview[v.value][i.scene_id][
                          item.value
                        ][k.value][x.value] = [];
                      });
                    });
                  });
                });
              });
              this.target_all = setting.project_overview;
            }
          }
        }, 100);
      });
    }

    await dispatchGetPerformanceDashboard(store, {
      project: this.localProject,
      scene_id: this.choice.scene as number | "",
      trend_type: this.platform,
      start: "",
      end: "",
      report_type: Number(this.typeForm.faType),
      subtype: Number(this.typeForm.sonType),
    });
    this.target_types?.forEach((item) => {
      this.performanceTrends_echarts(item.value, item.label);
      let performanceTrends: any = document.getElementById(
        "performance_trend_" + item.value
      );
      if (performanceTrends.children.length === 0) {
        performanceTrends.parentNode.parentNode.parentNode.style.display =
          "none";
        // performanceTrends.parentNode.style.display="block"
      } else {
        performanceTrends.parentNode.parentNode.parentNode.style.display =
          "block";
      }
    });
    
    // this.Highfrequency_echarts()
    
    this.line_loading = false;
    this.basic_loading = false;
    await this.get_is_super;
    // await this.getTestOverview;
    await this.dataProcessing;

    this.loading = false;
  }

  public getScripts(scene_id?: number | null) {
    const scriptList = readSimpleScriptList(store);
    if (scene_id) {
      return scriptList.filter((script) => script.scene === scene_id);
    } else {
      return scriptList;
    }
  }
  public test_type = [
    "性能测试",
    "QQ飞车测试",
    "分组标签报告",
    "局外皮肤测试",
    "局内皮肤测试",
    "炽热局内皮肤测试",
    "label标签报告",
    "热力图报告",
    "极限测试",
    "5V5真人测试",
    "--",
    "逆战标签报告",
    "5V5真人测试New",
    "皮肤管线",
    "GPU Counter",
    "QQ飞车GPU报告",
    "逆战GPU报告",
    "SimplePerf",
    "SimplePerf",
    "自动化内存测试",
    "分支性能",
    "主干性能",
    "分支dev",
    "主干dev",
    "Unity内存",
    "UI控件性能",
  ];
  // 空数据加--
  public get dataProcessing() {
    let list = [];
    this.get_all_performance.forEach((item: any) => {
      list.push(item.is_valid);
      item.newType = this.test_type[item.type];
      if (item.tester === null) {
        item.tester = item.task_record_id?.create_user;
      }
      item.RecordID = item.task_record_id;
      for (let i in item) {
        if (item[i] === "" || item[i] === null || item[i] === undefined) {
          item[i] = "--";
        }
      }
      if (item.task_record_id !== "--") {
        item.RecordID = item.task_record_id.id;
      }
    });
    console.log(list.every((v) => v == true));
    if (list.every((v) => v == true)) {
      this.is_valid = true;
    } else {
      this.is_valid = false;
    }
    return this.get_all_performance;
  }
  // 测试概况
  // public get getTestOverview() {
  //   const testOverview: any[] = [
  //     {
  //       title:
  //         '项目测试 <span style="color: #e3b65a;font-weight:600">报告</span> 数',
  //       value: this.get_perf_dashboard.report_num,
  //       styles: "background-color:#3280c8",
  //     },
  //     {
  //       title:
  //         '项目测试 <span style="color: #e3b65a;font-weight:600">场景</span> 数',
  //       value: this.get_perf_dashboard.test_scene_num,
  //       styles: "background-color:#48c3d3",
  //     },
  //     {
  //       title:
  //         '项目测试 <span style="color: #e3b65a;font-weight:600">机型</span> 数',
  //       value: this.get_perf_dashboard.test_device_num,
  //       styles: "background-color:#36ba88",
  //     },
  //     {
  //       title:
  //         '项目测试 <span style="color: #e3b65a;font-weight:600">安装包</span> 数',
  //       value: this.get_perf_dashboard.pipeline_download_num,
  //       styles: "background-color:#7877da",
  //     },
  //   ];
  //   return testOverview;
  // }
  // 获取下拉选择框
  public get performace_select_options() {
    const options = readPerformanceSelectOptions(store);
    return options;
  }
  // 获取主要数据
  public get get_perf_dashboard() {
    const res = readPerfDashboard(store);

    return res;
  }

  public get getScenes() {
    const scenes = readProjectScenes(store);
    return scenes;
  }

  // 场景
  public get scene_options() {
    const scene_list: any[] = this.performace_select_options.scene_list;
    // scene_list.forEach((scene) => {
    //   let chinese = this.getScenes.filter(
    //     (item: any) => item.id === Number(scene.scene_id)
    //   )[0]?.chinese;
    //   scene.chinese = chinese;
    // });
    return scene_list.sort(compare("count"));
  }
  // 设备
  public get all_device_options() {
    const devices = this.performace_select_options.device_list;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
      });
    });
    return device_select;
  }

  // 设备分组
  public get device_options() {
    const devices = this.performace_select_options.device_list;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item
      )[0];
      const name =
        device?.level +
        1 +
        "档机 - " +
        device?.model?.name +
        " - " +
        device?.model?.model;
      device_select.push({
        label: name,
        value: item,
        level: device?.level + 1,
      });
    });
    // 分组排序
    let map = {};
    let dest = [];
    for (let i = 0; i < device_select.length; i++) {
      let ai = device_select[i];
      if (!(map as any)[ai.level]) {
        dest.push({
          level: ai.level,
          label: ai.level + "档机",
          data: [ai],
        });
        (map as any)[ai.level] = ai;
      } else {
        for (let j = 0; j < dest.length; j++) {
          let dj = dest[j];
          if (dj.level == ai.level) {
            dj.data.push(ai);
            break;
          }
        }
      }
    }
    return dest.sort(compare("level"));
  }
  //自动化时间轴

  public get automated_task_timeline() {
    const timeline_list = this.get_perf_dashboard.timelines;
    timeline_list.forEach((item) => {
      if (item.game_version == "") {
        item.game_version = "--";
      }
    });
    // timeline_list.forEach(item => {
    //    if(item.status=="取消"){
    //     this.color1='dd'
    //    }
    //   else if(item.status=="完成"){
    //     this.color1='nt'
    //   }

    // });
    return timeline_list;
  }
  // 版本
  public get game_version_options() {
    const versions = this.performace_select_options.game_versions;
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item) {
        game_version_select.push({
          label: item,
          value: item,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return unique_json(game_version_select, "value");
  }
  public get judge() {
    let list = [
      { label: "有效", value: 1 },
      { label: "无效", value: 0 },
    ];
    return list;
  }
  public get readPerformancePageList() {
    return readPerformancePageList(store);
  }
  // 获取表格数据
  public get get_all_performance() {
    let res: any[] = readPerformancePageList(store).results;
    for (let i = 0; i < res.length; i++) {
      res[i].model = this.getDeviceSpecs.filter(
        (item) => item.id === res[i].device_id
      )[0]?.model.model;
      res[i].index = i + 1;
      res[i].timestamp = dateConversion(res[i].timestamp);
    }
    return res;
  }
  public get typefaList() {
    let list = [];
    let falseArray: any = [34, 40, 47, 12, 32];
    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
      ];
      this.typeForm.faType = 9;
    } else if (this.localProject === 32) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤异常测试", value: 13 },
      ];
      this.typeForm.faType = 0;
    } else if (this.localProject === 59) {
      list = [
        { name: "Default", value: 0 },
        { name: "关卡测试  ", value: 42 },
        { name: "UI测试", value: 43 },
        { name: "UI&关卡测试", value: 44 },
      ]
      this.typeForm.faType = 44;
    } else if (this.localProject === 18 || this.localProject === 14) {
      list = [
        { name: "Default", value: 0 },
        { name: "5V5真人测试", value: 9 },
      ];
      this.typeForm.faType = 0;
    } else if (this.localProject === 12) {
      list = [{ name: "Default", value: 0 }];
      this.typeForm.faType = 0;
    } else if (falseArray.every((v) => v != this.localProject)) {
      list = [{ name: "Default", value: 0 }];
      this.typeForm.faType = 0;
    }
    return list;
  }
  public get sonList() {
    let list = [];
    if (this.typeForm.faType == 13) {
      list = [
        { name: "局内", value: "0" },
        { name: "局外", value: "1" },
      ];
    } else if (this.typeForm.faType == 9) {
      list = [
        { name: "Default", value: "0" },
        { name: "开profile", value: "1" },
        { name: "关profile", value: "2" },
      ];
    } else {
      list = [{ name: "Default", value: "0" }];
    }

    return list;
  }
  // 序号
  public indexMethod(index: any) {
    return index + 1 + (this.current_page - 1) * this.record;
  }
  // 切换/分页
  public async selectTableChange(operation: any) {
    this.loading = true;

    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: this.indexValue === "" ? "" : Number(this.indexValue),
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: operation === "Search" ? 1 : this.current_page,
      size: this.record,
      is_valid:
        this.selected_table_judge === "" ? "" : this.selected_table_judge,
      custom_versions: this.custom.join(","),
    });
    await this.dataProcessing;
    this.loading = false;
  }
  public async blurUsername(operation: any) {
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: this.indexValue === "" ? "" : Number(this.indexValue),
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: operation === "Search" ? 1 : this.current_page,
      size: this.record,
      is_valid:
        this.selected_table_judge === "" ? "" : this.selected_table_judge,
      custom_versions: this.custom.join(","),
    });
    await this.dataProcessing;
  }

  // 全部清空
  public async onTableClear() {
    this.loading = true;
    this.selected_table_scene = [];
    this.selected_table_device = [];
    this.selected_table_version = [];
    this.custom = [];
    this.selected_table_judge = "";
    this.indexValue = "";
    this.record = 16;
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: "",
      scene_id_list: [],
      device_id_list: [],
      game_versions: [],
      page: 1,
      size: this.record,
      is_valid: "",
      custom_versions: "",
    });
    await this.dataProcessing;
    this.loading = false;
  }

  // 性能指标选择框
  public get target_side_by_side() {
    let targets = [
      ["avg_fps", "max_pss"],
      ["max_mono_used", "max_mono_total"],
      ["avg_cpu", "avg_dc"],
      ["lag_pcnt", "max_triangle"],
    ];
    // 根据不同项目展示不同指标，有些趋势图为空
    if (
      special_projects.cf.includes(this.localProject) ||
      special_projects.dfm.includes(this.localProject) ||
      special_projects.semi.includes(this.localProject)
    ) {
      targets = [
        ["avg_fps", "max_pss"],
        ["avg_cpu", "lag_pcnt"],
      ];
    }
    if (
      special_projects.speedm.includes(this.localProject) ||
      special_projects.test.includes(this.localProject)
    ) {
      targets = [
        ["avg_fps", "max_pss"],
        ["max_mono_used", "max_mono_total"],
        ["avg_cpu", "lag_pcnt"],
        ["cpu_power", "high_frequency"],
        ["count_frequency", "avg_framerate"],
      ];
    }
    return targets;
  }
  public get target_side_by_side1() {
    let targets = [
      "avg_fps",
      "max_pss",
      "max_mono_used",
      "max_mono_total",
      "avg_cpu",
      "avg_dc",
      "lag_pcnt",
      "max_triangle",
    ];
    if (special_projects.sg.includes(this.localProject)) {
      targets.push("loadingtime");
    }
    if (
      special_projects.cf.includes(this.localProject) ||
      special_projects.dfm.includes(this.localProject) ||
      special_projects.semi.includes(this.localProject)
    ) {
      targets = ["avg_fps", "max_pss", "avg_cpu", "lag_pcnt"];
    }
    if (
      special_projects.speedm.includes(this.localProject) ||
      special_projects.test.includes(this.localProject)
    ) {
      targets = [
        "avg_fps",
        "max_pss",
        "max_mono_used",
        "max_mono_total",
        "avg_cpu",
        "lag_pcnt",
        "cpu_power",
        "high_frequency",
        "count_frequency",
        "avg_framerate",
      ];
    }
    return targets;
  }
  // 性能指标选择框
  public get target_types() {
    let target_select = [
      {
        label: "平均FPS",
        value: "avg_fps",
      },
      {
        label: "峰值PSS",
        value: "max_pss",
      },
      {
        label: "mono堆内存",
        value: "max_mono_used",
      },
      {
        label: "峰值Total Mono",
        value: "max_mono_total",
      },
      {
        label: "平均CPU",
        value: "avg_cpu",
      },
      {
        label: "平均DC",
        value: "avg_dc",
      },
      {
        label: "卡顿率",
        value: "lag_pcnt",
      },
      {
        label: "峰值三角形(万)",
        value: "max_triangle",
      },
      {
        label: "CPU功耗趋势图",
        value: "cpu_power",
      },
      {
        label: "高帧率降频情况",
        value: "high_frequency",
      },
      {
        label: "降频次数趋势图",
        value: "count_frequency",
      },
      {
        label: "降频帧率趋势图",
        value: "avg_framerate",
      },
      {
        label: "loadingtime",
        value: "loadingtime",
      },
    ];
    if (
      special_projects.cf.includes(this.localProject) ||
      special_projects.dfm.includes(this.localProject) ||
      special_projects.semi.includes(this.localProject)
    ) {
      target_select.splice(2, 2);
      target_select.splice(3, 1);
      target_select.splice(4, 1);
      target_select.splice(4, 1);
      target_select.splice(4, 1);
      target_select.splice(4, 1);
      target_select.splice(4, 1);
      target_select.splice(4, 1);
    } else if (
      special_projects.speedm.includes(this.localProject) ||
      special_projects.test.includes(this.localProject)
    ) {
      target_select.splice(5, 1);
      target_select.splice(6, 1);
      target_select.splice(10, 1);
    } else if (special_projects.sg.includes(this.localProject)) {
      target_select.splice(8, 1);
      target_select.splice(8, 1);
      target_select.splice(8, 1);
      target_select.splice(8, 1);
    } else {
      target_select.splice(8, 1);
      target_select.splice(8, 1);
      target_select.splice(8, 1);
      target_select.splice(8, 1);
      target_select.splice(8, 1);
    }
    return target_select;
  }
  // 转换检测null
  public null2str(data: any) {
    if (typeof data != "object" || data === null || data === "null") {
      data = "";
      return data;
    } else {
      for (let x in data) {
        if (data[x] === null || data[x] === "null") {
          // 如果是null 把直接内容转为 ''
          data[x] = "";
        } else {
          if (Array.isArray(data[x])) {
            // 是数组遍历数组 递归继续处理
            data[x] = data[x].map((z: any) => {
              return this.null2str(z);
            });
          }
          if (typeof data[x] === "object") {
            // 是json 递归继续处理
            data[x] = this.null2str(data[x]);
          }
        }
      }
      return data;
    }
  }
  public get getDeviceSpecs() {
    return readDeviceSpecs(store);
  }
  // 高频率降频情况趋势图

  // public  Highfrequency_echarts(){
  //   //  let b= this.get_perf_dashboard.cpu_trend
  //   //   b.cpu.forEach(function(v:any,index:any){
  //   //     if(v[index].length>1){
  //   //         b.cpu.x_axis.push()
  //   //     }

  //   //   })
  //   let a=this.get_perf_dashboard.cpu_trend.cpu.flat()
  //   let b=this.get_perf_dashboard.cpu_trend.timeline.flat()
  //   let ydata=[]
  //   let bdata:any=[]
  //   let m=[]
  //   let c=["01:22","03:33"]
  //   for(let i=0;i<12;i++){
  //     ydata.push('00:'+String(i*5).padStart(2,'0'))
  //   }
  //   b.forEach(function(v:any){
  //     m=v.split(":")
  //     let x=Number(m[0]*60)+Number(m[1])
  //     console.log(x)
  //     bdata.push(Number(m[0]*60)+Number(m[1]))

  //   })
  //   console.log(bdata)
  //    var chartDom = document.getElementById("Highfrequency") as HTMLElement;
  //     var myChart = echarts.init(chartDom);

  //      myChart.setOption({
  //         title: {
  //             text: '高帧率降频情况',
  //             left: "1%",
  //         },
  //         // tooltip : {
  //         //     trigger: 'item',
  //         //     formatter: "{a} <br/>{b} : {c}次"
  //         //  },
  //           tooltip: {
  //         trigger: "axis",
  //       }, //悬浮框显示
  //         // toolbox: {
  //         //     show : true,
  //         //     top:10,
  //         //     right:10,
  //         //     feature : {
  //         //         mark : {show: true},
  //         //         magicType : {show: true, type: ['line', 'bar']},
  //         //         restore : {show: true},
  //         //         saveAsImage : {show: true}
  //         //     }
  //         // },
  //         toolbox: {
  //         feature: {
  //           saveAsImage: {},
  //           magicType: { show: true, type: ["bar", "line"] },
  //         },
  //       },
  //         // grid:{
  //         //     top:60,
  //         //     right:70,
  //         //     bottom:30,
  //         //     left:60
  //         // },
  //         grid: {
  //         left: "5%",
  //         right: "3%",
  //         top: "15%",
  //         bottom: "15%",
  //         containLabel: true,
  //       },
  //         legend: {
  //             // top:32,
  //             // left:'center',
  //             data:['降频频率','时间'],
  //             x: "center",
  //             y: "bottom",
  //             type: "scroll",
  //         },
  //         calculable : true,
  //         xAxis : [
  //             {
  //                 type : 'category',
  //                 data : this.get_perf_dashboard.cpu_trend.x_axis
  //             }
  //         ],
  //         yAxis : [
  //             {
  //                 type: 'value',
  //                 name:"频率",

  //                 nameTextStyle:{
  //                     fontSize: 12,
  //                 },

  //                 //默认以千分位显示，不想用的可以在这加一段
  //                 axisLabel : {   //调整左侧Y轴刻度， 直接按对应数据显示
  //                     show:true,
  //                     showMinLabel:true,
  //                     showMaxLabel:true,
  //                     formatter: function (value:any) {
  //                         return value;
  //                     }
  //                 }
  //             },
  //             {
  //                 type: 'value',
  //                 // min: `${BASE_TIME} 0:00:00`,
  //                 //  max: `${BASE_TIME} 23:59:59`,
  //                 name:"秒",
  //               splitLine: { show: false },
  //                 nameTextStyle:{
  //                     fontSize: 12,
  //                 },
  //                 //默认以千分位显示，不想用的可以在这加一段
  //                 // axisLabel : {   //调整左侧Y轴刻度， 直接按对应数据显示
  //                 //     show:true,
  //                 //     showMinLabel:true,
  //                 //     showMaxLabel:true,
  //                 //     formatter: function (value:any) {
  //                 //         return value;
  //                 //     }
  //                 // }
  //             }
  //         ],
  //         series : [
  //             {
  //                 name:'降频频率',
  //                 type:'line',
  //                 smooth: true,
  //                 yAxisIndex: 0,
  //                 data:a,
  //                 itemStyle : { normal: {label : {show: true}}},
  //             },
  //             {
  //                 name:'时间',
  //                 type:'line',
  //                 smooth: true,
  //                 yAxisIndex: 1,
  //                 data: bdata,
  //                 itemStyle : { normal: {label : {show: true}}},
  //             }
  //         ]
  //     })

  //     return myChart

  // }
  // 使用echarts---性能趋势
  public show = true;
  public timer = "";
  public tarGet = "";
  public dialogTableVisible = false;
  public label_input = "";
  public target_all = {};
  public target_index = "";
  public custom = [];
  public async labelBtn() {
    let type = this.platform; //平台
    let scene = this.choice.scene; //场景
    let test = this.typeForm.faType; //测试类型
    let sonTest = this.typeForm.sonType; //子类型
    let target = this.tarGet; //指标
    let setting = JSON.parse(this.b.rule_settings as any);
    if (this.label_input) {
      // setting.project_overview={}
      //  setting.project_overview[type]={}
      //  setting.project_overview[type][scene]={}
      //  setting.project_overview[type][scene][test]={}

      // setting.project_overview[type][scene][test][sonTest]={}
      // setting.project_overview[type][scene][test][sonTest][target]=[]

      this.target_all[type][scene][test][sonTest][target].push({
        silent: false,
        xAxis: this.timer,
        label: {
          normal: {
            show: true,
            position: "end",
            formatter: this.label_input,
            textStyle: {
              color: "black", //标注线终点文字颜色
              fontSize: 16,
              fontWeight: 800,
              padding: [0, 0, 10, 0], //文字间距
            },
          },
        },
        lineStyle: {
          // type: "solid",
          color: "#ED5664",
          width: "3",
          fontSize: 15,
        },
      });
      this.performanceTrends_echarts(this.tarGet, this.target_index);
      this.dialogTableVisible = false;
      ElMessage({
        message: "添加成功",
        type: "success",
      });
      setting.project_overview = this.target_all;
      const Receiver = {
        project_key: readProjectDetail(store).project_key,
        project: this.localProject,
        report_settings: readProjectDetail(store).report_settings,
        rule_settings: JSON.stringify(setting),
      };
      await dispatchUpdateProject(store, {
        id: readProjectDetail(store).id as number,
        project: Receiver,
      });
    } else {
      ElMessage.error("请输入内容或者取消");
    }
  }
  public performanceTrends_echarts(target: string, target_label: string) {
    // 数据

    const ordinates: any[] = [];

    let target_values_name: any = [];
    // 初始化数据
    this.get_perf_dashboard.series.forEach((item: any[], index) => {
      let target_values: any = [];
      item.forEach((item) => {
        target_values.push(item[target]);
        target_values_name.push(item[target]);
      });

      // if(target_values){

      // }
      ordinates.push({
        name: this.get_perf_dashboard.device_names[index],
        type: "line",
        data: target_values,
        smooth: true,
        itemStyle: { normal: { label: { show: true } } },
      });
    });

    let type = this.platform; //平台
    let scene = this.choice.scene; //场景
    let test = this.typeForm.faType; //测试类型
    let sonTest = this.typeForm.sonType; //子类型

    if (this.localProject === 34) {
      ordinates[0].markLine = {
        data: [],
      };
      ordinates[0].markLine.data = this.target_all[type][scene][test][sonTest][
        target
      ];
    }
    this.null2str(target_values_name);

    // console.log(target_values);

    if (target_values_name.every((v: any) => v === "") === false) {
      this.show = true;

      let performanceTrends: any = document.getElementById(
        "performance_trend_" + target
      );
      echarts.dispose(performanceTrends);
      let PerformanceLineChart = echarts.init(performanceTrends);
      if (this.localProject == 34) {
        let setting = JSON.parse(this.b.rule_settings as any);

        PerformanceLineChart.on("click", (params) => {
          if (params.componentType == "series") {
            this.timer = params.name;
            this.tarGet = target;
            this.target_index = target_label;
            this.dialogTableVisible = true;
          }
          if (params.componentType === "markLine") {
            (this as any)
              .$confirm(
                "删除标记点: " +
                  this.target_all[type][scene][test][sonTest][target].filter(
                    (v) => v.xAxis === params.value
                  )[0].label.normal.formatter +
                  "?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
              .then(() => {
                let i = -1;

                this.target_all[type][scene][test][sonTest][target].forEach(
                  (item, index) => {
                    if (item.xAxis === params.value) {
                      i = index;
                    }
                  }
                );
                this.target_all[type][scene][test][sonTest][target].splice(
                  i,
                  1
                );
                setting.project_overview = this.target_all;

                const Receiver = {
                  project_key: readProjectDetail(store).project_key,
                  project: this.localProject,
                  report_settings: readProjectDetail(store).report_settings,
                  rule_settings: JSON.stringify(setting),
                };
                dispatchUpdateProject(store, {
                  id: readProjectDetail(store).id as number,
                  project: Receiver,
                });
                (this as any).$message({
                  type: "success",
                  message: "删除成功",
                });

                PerformanceLineChart.setOption({
                  series: ordinates,
                });
              });
          }
        });
      }

      let option;
      let min_value = 0
      if (target_label === "平均FPS") {
        min_value = 15
      } else if (target_label === "峰值PSS") {
        min_value = 500
      }

      option = {
        title: {
          text: target_label,
          left: "1%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          x: "center",
          y: "bottom",
          padding: [50, 0, 0, 0],
          data: this.get_perf_dashboard.device_names,
          type: "scroll",
        },
        grid: {
          left: "5%",
          right: "3%",
          top: "15%",
          bottom: "15%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
            magicType: { show: true, type: ["bar", "line"] },
          },
        },

        xAxis: {
          type: "category",
          boundaryGap: false,

          data: (this.get_perf_dashboard.x_axis as any[]).map((item) =>
            item.indexOf("(") !== -1 ? item.split("(")[0] + "]" : item
          ),
          offset: 20,
        },
        yAxis: {
          type: "value",
          min: min_value,
          // offset: 20,
          // scale: true,
        },
        series: ordinates,
      };
      if (target === "high_frequency") {
        let a = this.get_perf_dashboard.cpu_trend.cpu.flat();
        let b = this.get_perf_dashboard.cpu_trend.timeline.flat();
        let c = this.get_perf_dashboard.cpu_trend.timeline2.flat();
        let d = this.get_perf_dashboard.cpu_trend.cpu2.flat();
        let bdata: any = [];
        let cdata: any = [];
        let m = [];
        let m1 = [];
        b.forEach(function (v: any) {
          m = v.split(":");

          bdata.push(
            Number(((Number(m[0] * 60) + Number(m[1])) / 60).toFixed(2))
          );
        });
        c.forEach(function (v: any) {
          m1 = v.split(":");

          cdata.push(
            Number(((Number(m1[0] * 60) + Number(m1[1])) / 60).toFixed(2))
          );
        });
        option.xAxis.data = this.get_perf_dashboard.cpu_trend.x_axis;
        option.legend.data = [
          "第一次降频频率",
          "第二次降频频率",
          "第一次降频时间",
          "第二次降频时间",
        ];
        option.series = [
          {
            name: "第一次降频频率",
            type: "line",
            smooth: true,
            yAxisIndex: 0,
            data: a,
            itemStyle: { normal: { label: { show: true } } },
          },
          {
            name: "第二次降频频率",
            type: "line",
            smooth: true,
            yAxisIndex: 0,
            data: d,
            itemStyle: { normal: { label: { show: true } } },
          },
          {
            name: "第一次降频时间",
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            data: bdata,
            itemStyle: { normal: { label: { show: true } } },
          },
          {
            name: "第二次降频时间",
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            data: cdata,
            itemStyle: { normal: { label: { show: true } } },
          },
        ];
        (option.yAxis as any) = [
          {
            type: "value",
            name: "频率",

            nameTextStyle: {
              fontSize: 12,
            },

            //默认以千分位显示，不想用的可以在这加一段
            axisLabel: {
              //调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value: any) {
                return value;
              },
            },
          },
          {
            type: "value",
            // min: `${BASE_TIME} 0:00:00`,
            //  max: `${BASE_TIME} 23:59:59`,
            name: "分钟",
            splitLine: { show: false },
            nameTextStyle: {
              fontSize: 12,
            },
            //默认以千分位显示，不想用的可以在这加一段
            // axisLabel : {   //调整左侧Y轴刻度， 直接按对应数据显示
            //     show:true,
            //     showMinLabel:true,
            //     showMaxLabel:true,
            //     formatter: function (value:any) {
            //         return value;
            //     }
            // }
          },
        ];
      }
      if (target === "count_frequency") {
        option.xAxis.data = this.get_perf_dashboard.cpu_trend.x_axis;
        (option.legend.data = ["降频次数"]),
          (option.series = [
            {
              name: "降频次数",
              type: "line",
              data: this.get_perf_dashboard.cpu_trend.count,
              smooth: true,
              itemStyle: { normal: { label: { show: true } } },
            },
          ]);
      }
      if (target === "avg_framerate") {
        let avgFramerate = [
          { name: "第一次降频前平均帧率", label: "clock7_1" },
          { name: "第一次降频后到第二次降频间的平均帧率", label: "clock7_2" },
          { name: "第二次降频后的的平均帧率", label: "clock7_3" },
        ];
        let series: any = [];
        option.legend.data = avgFramerate.map((v) => v.name);
        avgFramerate.forEach((v) => {
          series.push({
            name: v.name,
            type: "line",
            data: this.get_perf_dashboard.cpu_trend[v.label],
            smooth: true,
            itemStyle: { normal: { label: { show: true } } },
          });
        });

        option.series = series;

        option.xAxis.data = (this.get_perf_dashboard.cpu_trend
          .x_axis as any[]).map((item) =>
          item.indexOf("(") !== -1 ? item.split("(")[0] + "]" : item
        );
      }

      console.log('option', option)
      PerformanceLineChart.setOption(option);
      return PerformanceLineChart;
    } else {
      this.show = false;
    }
  }

  // 场景切换
  public async selectSceneChange(item) {
    this.line_loading = true;
    if (item) {
      this.typeForm.sonType = "0";
    }
    let startTime = "";
    let endTime = "";
    if (this.valueTime) {
      let startTimeAll = dateConversion(this.valueTime[0]);
      let endTimeAll = dateConversion(this.valueTime[1]);
      startTime = startTimeAll.split(" ")[0];
      endTime = endTimeAll.split(" ")[0];
    }

    await dispatchGetPerformanceDashboard(store, {
      project: this.localProject,
      scene_id: this.choice.scene as number | "",
      trend_type: this.platform,
      start: startTime,
      end: endTime,
      report_type: Number(this.typeForm.faType),
      subtype: Number(this.typeForm.sonType),
    });
    this.target_types?.forEach((item) => {
      let performanceTrends: any = document.getElementById(
        "performance_trend_" + item.value
      );
      if (this.get_perf_dashboard.series.length > 0) {
        performanceTrends.parentNode.parentNode.parentNode.style.display =
          "block";
        this.performanceTrends_echarts(item.value, item.label);
        if (performanceTrends.children.length === 0) {
          performanceTrends.parentNode.parentNode.parentNode.style.display =
            "none";
          // performanceTrends.parentNode.style.display="block"
        } else {
          performanceTrends.parentNode.parentNode.parentNode.style.display =
            "block";
        }
      } else {
        performanceTrends.parentNode.parentNode.parentNode.style.display =
          "none";
        this.performanceTrends_echarts(item.value, item.label);
      }

      // this.performanceTrends_echarts(item.value, item.label);

      // console.log(performanceTrends.parentNode.parentNode.parentNode)
      // if (performanceTrends.children.length === 0) {
      //   performanceTrends.parentNode.parentNode.parentNode.style.display = "none";
      //   // performanceTrends.parentNode.style.display="block"
      // } else {
      //   performanceTrends.parentNode.parentNode.parentNode.style.display = "block";
      // }
      // console.log(performanceTrends);
    });

    // this.Highfrequency_echarts()
    this.line_loading = false;
  }

  // 有效
  public async IsValidChange(row: any) {
    this.loading = true;
    const upload_data = {
      id: row.id,
      is_valid: row.is_valid,
      task_group_index: row.task_group_index,
      device_id: row.device_id,
      scene_id: row.scene_id.id,
      project: row.project.id,
      timestamp: row.timestamp,
    };
    await dispatchDataValid(store, {
      id: row.id,
      project: row.project.id,
      data: upload_data,
    });
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: this.indexValue === "" ? "" : Number(this.indexValue),
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: this.current_page,
      size: this.record,
      is_valid:
        this.selected_table_judge === "" ? "" : this.selected_table_judge,
      custom_versions: this.custom.join(","),
    });
    await this.dataProcessing;
    this.loading = false;
  }
  // 时间选择
  public async timeChange() {
    // console.log(this.f)
    // this.valueTime=this.defaultDateRange
    // let b=dateConversion(new Date()).split(' ')[0]
    // console.log(this.value1)
    //  this.defaultTime=new Date(b)
    let startTimeAll = dateConversion(this.valueTime[0]);
    let endTimeAll = dateConversion(this.valueTime[1]);
    let startTime = startTimeAll.split(" ")[0];
    let endTime = endTimeAll.split(" ")[0];

    await dispatchGetPerformanceDashboard(store, {
      project: this.localProject,
      scene_id: this.choice.scene as number | "",
      trend_type: this.platform,
      start: startTime,
      end: endTime,
      report_type: Number(this.typeForm.faType),
      subtype: Number(this.typeForm.sonType),
    });
    this.target_types?.forEach((item) => {
      let performanceTrends: any = document.getElementById(
        "performance_trend_" + item.value
      );
      if (this.get_perf_dashboard.series.length > 0) {
        performanceTrends.parentNode.parentNode.parentNode.style.display =
          "block";
        this.performanceTrends_echarts(item.value, item.label);
        if (performanceTrends.children.length === 0) {
          performanceTrends.parentNode.parentNode.parentNode.style.display =
            "none";
          // performanceTrends.parentNode.style.display="block"
        } else {
          performanceTrends.parentNode.parentNode.parentNode.style.display =
            "block";
        }
      } else {
        performanceTrends.parentNode.parentNode.parentNode.style.display =
          "none";
        this.performanceTrends_echarts(item.value, item.label);
      }

      // this.performanceTrends_echarts(item.value, item.label);

      // console.log(performanceTrends.parentNode.parentNode.parentNode)
      // if (performanceTrends.children.length === 0) {
      //   performanceTrends.parentNode.parentNode.parentNode.style.display = "none";
      //   // performanceTrends.parentNode.style.display="block"
      // } else {
      //   performanceTrends.parentNode.parentNode.parentNode.style.display = "block";
      // }
      // console.log(performanceTrends);
    });
    // this.Highfrequency_echarts()
    // console.log(this.target_types)
  }
  //详情的路径
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 获取设备列表
  public get DeviceSpecs() {
    return readDeviceSpecs(store);
  }
  // 判断上传的是不是excel文件
  public beforeUpload(file: any) {
    let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    let isLt2M = file.size / 1024 / 1024 < 50;
    if (["xls", "xlsx"].indexOf(extension) === -1) {
      ElMessage.error({
        message: "只能上传后缀是.xlsx/.xls的文件",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload"] as any).clearFiles();
    }
    if (!isLt2M) {
      ElMessage.error({
        message: "上传文件大小不能超过50MB!",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload"] as any).clearFiles();
    }
    return extension && isLt2M;
  }
  // 判断上传的是不是excel文件
  public beforeUploadRunmax(file: any) {
    let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
    let isLt2M = file.size / 1024 / 1024 < 50;
    if (["csv"].indexOf(extension) === -1) {
      ElMessage.error({
        message: "只能上传后缀是.csv的文件",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload_runmax"] as any).clearFiles();
    }
    if (!isLt2M) {
      ElMessage.error({
        message: "上传文件大小不能超过50MB!",
        showClose: true,
        type: "error",
      });
      (this.$refs["upload_runmax"] as any).clearFiles();
    }
    return extension && isLt2M;
  }

  // 确定
  public formData: any = new FormData();
  public async UploadFile(param: any) {
    this.formData.append("file", param.file);
  }
  public async UploadRunmaxFile(param: any) {
    this.formData.append("file", param.file);
  }
  public async submitUpload(btn: string) {
    if (btn === "ok") {
      this.loading = true;
      this.formData.append("scene_id", Number(this.dialogForm.scene_id));
      this.formData.append("script_id", Number(this.dialogForm.script_id));
      this.formData.append("task_record_id", this.dialogForm.task_record_id);
      this.formData.append(
        "task_group_index",
        this.dialogForm.task_group_index
      );
      this.formData.append(
        "is_valid",
        this.dialogForm.is_valid === true ? 1 : 0
      );
      this.formData.append(
        "b_auto_collect",
        this.dialogForm.b_auto_collect === true ? 1 : 0
      );
      this.formData.append("remark", this.dialogForm.remark);
      this.formData.append("is_dfm_ios", 0);
      this.formData.append("UUID", this.dialogForm.UUID);
      this.formData.append("project", this.localProject);
      this.dialogVisible = false;
      await dispatchUploadPerformance(store, this.formData);
      await dispatchGetPerformancePageList(store, {
        project: this.localProject,
        task_record_id: "",
        scene_id_list: [],
        device_id_list: [],
        game_versions: [],
        page: 1,
        size: this.record,
        is_valid: "",
        custom_versions: "",
      });
      await this.dataProcessing;
      ElMessage.success({
        message: "数据上传成功",
        showClose: true,
        type: "success",
      });
      this.loading = false;
      this.formData = new FormData();
    }
    if (btn === "no") {
      this.dialogForm = {
        scene_id: "",
        script_id: "",
        is_valid: true,
        b_auto_collect: false,
        remark: "",
        UUID: "",
        task_record_id: "",
        task_group_index: "",
      };
      this.formData = new FormData();
      (this.$refs["upload"] as any).clearFiles();
    }
    if (btn === "open") {
      this.dialogVisible = true;
      this.dialogForm = {
        scene_id: "",
        script_id: "",
        is_valid: true,
        b_auto_collect: false,
        remark: "",
        UUID: "",
        task_record_id: "",
        task_group_index: "",
      };
      this.formData = new FormData();
      (this.$refs["upload"] as any).clearFiles();
    }
  }
  public is_valid = true;
  public async handleSelect(value: any, row: any) {
    this.get_all_performance.forEach((v) => {
      if (this.is_valid) {
        v.is_valid = true;
      } else {
        v.is_valid = false;
      }
    });
    const upload_data = {
      project: this.localProject,
      valid_id_list: this.get_all_performance.map((v) => v.id),
      is_valid: this.is_valid,
    };
    await dispatchPerforMance(store, {
      data: upload_data,
    });
    await dispatchGetPerformancePageList(store, {
      project: this.localProject,
      task_record_id: this.indexValue === "" ? "" : Number(this.indexValue),
      scene_id_list: this.selected_table_scene,
      device_id_list: this.selected_table_device,
      game_versions: this.selected_table_version,
      page: this.current_page,
      size: this.record,
      is_valid:
        this.selected_table_judge === "" ? "" : this.selected_table_judge,
      custom_versions: this.custom.join(","),
    });
    await this.dataProcessing;

    // value.forEach(function(v:any){
    //    if(value.every((k:any)=>k.is_valid==true)){
    //      v.is_valid=false
    //    }else{
    //      v.is_valid=true
    //    }
    // })
  }
  // 上传runamx
  public async UploadRunmax(btn: string) {
    if (btn === "ok") {
      this.loading = true;
      this.formData.append("scene_id", Number(this.dialogRunmaxForm.scene_id));
      this.formData.append("script_id", this.dialogRunmaxForm.script_id);
      this.formData.append(
        "task_record_id",
        this.dialogRunmaxForm.task_record_id
      );
      this.formData.append(
        "task_group_index",
        this.dialogRunmaxForm.task_group_index
      );

      this.formData.append("device_id", this.dialogRunmaxForm.UUID);
      this.formData.append("project", this.localProject);
      this.dialogVisibleRunmax = false;
      await dispatchUploadPerformanceAll(store, this.formData);
      await dispatchGetPerformancePageList(store, {
        project: this.localProject,
        task_record_id: "",
        scene_id_list: [],
        device_id_list: [],
        game_versions: [],
        page: 1,
        size: this.record,
        is_valid: "",
        custom_versions: "",
      });
      await this.dataProcessing;
      ElMessage.success({
        message: "数据上传成功",
        showClose: true,
        type: "success",
      });
      this.formData = new FormData();
      this.loading = false;
    }
    if (btn === "no") {
      this.dialogRunmaxForm = {
        scene_id: "",
        task_record_id: "",
        script_id: "",
        task_group_index: "",
        UUID: "",
      };
      this.formData = new FormData();
      (this.$refs["upload_runmax"] as any).clearFiles();
    }
    if (btn === "open") {
      this.dialogVisibleRunmax = true;
      this.dialogRunmaxForm = {
        scene_id: "",
        task_record_id: "",
        script_id: "",
        task_group_index: "",
        UUID: "",
      };
      this.formData = new FormData();
      (this.$refs["upload_runmax"] as any).clearFiles();
    }
  }

  public platform = this.localProject == 59 ? '' : 0;
  //public platform = 0;
  public platformArr = [
    {
      label: "Android",
      value: 0,
    },
    {
      label: "iOS",
      value: 1,
    },
    {
      label: "PC",
      value: 2,
    },
  ];
  // 平台选择
  public async platformChoice() {
    await dispatchGetPerformanceDashboard(store, {
      project: this.localProject,
      scene_id: this.choice.scene as number | "",
      trend_type: this.platform,
      start: "",
      end: "",
      report_type: Number(this.typeForm.faType),
      subtype: Number(this.typeForm.sonType),
    });
  }
}
